export default __webpack_public_path__ + "static/media/collectionPlaceholderImage.e228eff5.svg";